import SimpleCMP from './SimpleCMP';

export default SimpleCMP;
